export default "__VITE_ASSET__SvUx5yRw__"